/**
 * Open a PDF in the theme's shared viewer modal (#modal-pdf-links).
 * Falls back to a new tab when the modal isn't available (e.g. outside portal pages).
 */
export function openPortalPdf(pdfUrl, pdfTitle) {
  if (!pdfUrl || typeof window === 'undefined') return;

  const isDesktop = window.matchMedia('screen and (min-width: 640px)').matches;

  if (isDesktop && window.openPdfInModal) {
    window.openPdfInModal(pdfUrl, encodeURIComponent(pdfTitle || ''));
  } else {
    window.open(pdfUrl, '_blank', 'noopener,noreferrer');
  }
}




export const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop().split(';').shift();
  }
};
export const setCookie = (name = 'cart', value, days = 14) => {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${value}; expires=${expires}; path=/; SameSite=Lax`;
};

export const updateCartCookie = (value) => setCookie('cart', value, 14);


export function numericStringOrNull(value) {
  if (value == null) return null;
  const n = parseFloat(String(value).replace(/[^0-9.]/g, ''));
  return Number.isFinite(n) ? String(n) : null;
}
export const safeJsonParse = (raw, fallback = {}) => {
  if (!raw) return fallback;
  try {
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : fallback;
  } catch {
    return fallback;
  }
};


export const getGAClientId = () => {
  try {
    if (typeof document === 'undefined' || typeof document.cookie !== 'string') return undefined;

    const raw = document.cookie;
    if (!raw) return undefined;

    // Expected format: "_ga=GA1.1.1234567890.1234567890"
    // We only want the GA "client id" portion: "1234567890.1234567890"
    const gaPair = raw.split(';').map((s) => s.trim()).find((s) => s.startsWith('_ga='));
    if (!gaPair) return undefined;

    const gaValue = gaPair.split('=').slice(1).join('=').trim();
    if (!gaValue) return undefined;
    const parts = gaValue.split('.').filter(Boolean);
    if (parts.length < 2) return undefined;

    return parts.slice(-2).join('.');
  } catch (e) {
    return undefined;
  }
}

export const trackKlaviyoEvent = (eventName, properties = {}) => {
  if (typeof window === 'undefined') return;
  const learnq = window._learnq || [];
  learnq.push(['track', eventName, properties]);
};

export function pushDataLayerEvent(eventName, payload = {}) {
  if (typeof window === 'undefined') return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: eventName, ...payload });
}


/**
 * @param {string} orderId
 * @param {string} token
 * @param {string} [quoteName]
 * @param {{ openPdf?: boolean }} [options] — set `openPdf: true` to add `open_pdf=1` (auto-opens PDF on load)
 */
export function getShareUrl(orderId, token, quoteName = '', options = {}) {
  const { openPdf } = options;
  const base = window.location.origin + window.location.pathname;
  const params = new URLSearchParams();
  if (token) params.set('token', token);
  if (quoteName) params.set('quote_name', quoteName);
  if (openPdf) params.set('open_pdf', '1');
  const qs = params.toString();
  const hash = `#/draft-order/${orderId}`;
  return qs ? `${base}?${qs}${hash}` : `${base}${hash}`;
}






export function parseEmails(input) {
  if (!input || !String(input).trim()) return [];
  return String(input)
    .split(/[\s,;]+/)
    .map((e) => e.trim().toLowerCase())
    .filter((e) => e.length > 0 && e.includes('@'));
}


const isWithinSupportHours = (date = new Date()) => {
  // Example: Mon–Fri, 8:00–17:00 Central Time
  const zoned = new Date(date.toLocaleString('en-US', { timeZone: 'America/Chicago' }));
  const day = zoned.getDay();        // 0=Sun, 1=Mon, ...
  const hour = zoned.getHours();     // 0–23

  const isWeekday = day >= 1 && day <= 5;
  const inHours = hour >= 8 && hour < 17;
  // console.log('isWithinSupportHours', isWeekday, 'hour', hour, 'inHours', inHours);
  // return false;
  return isWeekday && inHours;
};

/**
 * Open Gorgias chat widget if loaded. Returns a promise that resolves to true if opened, false if widget not available.
 * @param {string} [prefillMessage] - Optional message to send when chat opens (e.g. "Question about quote #1234")
 */
export function openGorgiasChat(prefillMessage) {
  if (!isWithinSupportHours()) {
    return Promise.resolve(false); // trigger handleAskQuestion fallback
  }

  // console.log('openGorgiasChat', isWithinSupportHours);

  const init = window.GorgiasChat
    ? window.GorgiasChat.init()
    : new Promise((resolve) => {
        window.addEventListener('gorgias-widget-loaded', () => resolve(), { once: true });
        setTimeout(() => resolve(), 3000);
      });

  return init
    .then(() => {
      if (typeof window.GorgiasChat?.open !== 'function') return false;
      window.GorgiasChat.setCurrentInput(`${prefillMessage}`);
      window.GorgiasChat.open();
      return true;
    })
    .catch(() => false);
}

export const klavityoPortalItems = (items) => {
  return items.map(function(product) {
    return {
      "ProductName": product.title,
      "ProductID": product.productLegacyResourceId,
      "SKU": product.sku,
      "VaritantID": product.variantId,
      "ItemPrice": product.price,
      "Quantity": product.quantity,
      "RowTotal": (product.price) * product.quantity,
      "Brand": product.vendor,
      "ProductURL": location.href.split( '/' )[0] + '//' + location.href.split( '/' )[2] + '/products/' + product.handle,
      "ImageURL": product.image,
    }
  });
}

